import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ReadMoreComponent } from "../../read-more/read-more.component";
import { AlertComponent } from '../../../poker-room/alert.component';


@Component({
    selector: 'whocan-alert-1',
    standalone: true,
    imports: [
        CommonModule,
        AlertComponent,

    ],
    templateUrl: './whocan-alert-1.html',
})

export class WhocanAlert1Component {

    constructor(
    ) {
    }

}
